function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.584585 21.4108C1.34782 22.2194 2.64981 22.1745 3.36814 21.321L7.18431 16.8738L7.319 17.0085C7.49859 17.1882 7.81286 17.1882 7.99244 17.0085L8.17203 16.8288C7.00473 16.0652 5.92722 15.032 5.16399 13.8191L4.9844 13.9988C4.80482 14.1785 4.80482 14.4929 4.9844 14.6726L5.11909 14.8074L0.674377 18.6257C-0.178649 19.3444 -0.223545 20.6472 0.584585 21.4108Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.1394 2.54369C10.5515 -0.825397 16.0288 -0.870318 19.4409 2.54369C22.853 5.95769 22.853 11.483 19.4409 14.897C16.0288 18.311 10.5066 18.311 7.0945 14.897C3.6824 11.3931 3.7722 5.86785 7.1394 2.54369ZM9.06993 12.9205C11.4045 15.2564 15.1758 15.2564 17.5104 12.9205C19.845 10.5846 19.845 6.81119 17.5104 4.47529C15.1758 2.1394 11.4045 2.1394 9.06993 4.47529C6.73534 6.81119 6.73534 10.5846 9.06993 12.9205Z",
  fill: "white"
});

function SvgZoomLens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomLens);
export default __webpack_public_path__ + "static/media/zoom-lens.d84f304c.svg";
export { ForwardRef as ReactComponent };